import { MosaicVideo } from 'components/commercetools-ui/organisms/gallery/gallery-mosaic';

/**
 * Product videos for the PDP mosaic, matched on the parent product's slug.
 *
 * EXPLORATION: a hand-kept list while we learn how video performs on the PDP. If it earns its place,
 * this belongs in content (Cloudinary tags or Contentful) next to the lifestyle photos, not in code.
 */
const PRODUCT_VIDEOS: Array<{ slug: RegExp; youtubeId: string; title: string; duration?: string }> = [
  {
    // DriveTite cable tension kits only (Express and Signature, level and angle), not the wrench,
    // the installation tool kit or the RodTite rod kits.
    slug: /drivetite.*tension-kit$/,
    youtubeId: 'XpnUXZ18pNc',
    title: 'How to Install DriveTite Cable Railing',
  },
  {
    // Every Express cable product: posts, kits, component kits, fittings and handrails.
    slug: /^(express-|cable-railing-express-)/,
    youtubeId: '84OQsSbDioY',
    title: 'Express Cable Railing | Product Showcase',
    duration: '2:10',
  },
];

// Built once per entry, so a product's video keeps one object identity across renders (the phone
// carousel finds the video slide by reference) without callers memoizing it.
const MOSAIC_VIDEOS = PRODUCT_VIDEOS.map(({ slug, youtubeId, title, duration }) => ({
  slug,
  video: {
    title,
    duration,
    youtubeId,
    // YouTube's own still (always present, unlike maxresdefault on older uploads).
    poster: { src: `https://i.ytimg.com/vi/${youtubeId}/hqdefault.jpg`, alt: '' },
  } satisfies MosaicVideo,
}));

export const getProductVideo = (slug?: string): MosaicVideo | undefined =>
  slug ? MOSAIC_VIDEOS.find((entry) => entry.slug.test(slug))?.video : undefined;
